<template>
  <div>
    <el-card>
      <div slot="header">
        <span class="text-muted">相關商品</span>
      </div>
      <el-empty v-if="!sources.length" />
      <div v-else class="mx-auto d-flex overflow-auto">
        <PromotionProductItem
          v-for="item in sources"
          :key="item?.id"
          :item="item"
          :display-coin-reward="item?.display_coin_reward"
          :is_login="is_login"
          :is-distribute="isDistribute"
          :store-data="storeData"
          @add="handleAddToCart"
          @quick-add="handleQuickAddToCart"
          @show="handleShowItem"
          @show-coin="showCoinLevel"
          @view="handleQuickView"
        />
      </div>
    </el-card>
    <!-- 商品規格選擇 Modal -->
    <ProductAssortSelectModal 
      :data="modalState" 
      :loading="loading"
      @add-to-cart="addToCartByAssort"
      @buy-now="buyNowByAssort" 
    />
    <!-- 商品詳情 -->
    <PromotionProductQuickView
      v-if="state.prodVisible"
      v-model="state.prodVisible"
      :product="modalState.item"
      :is-distribute="isDistribute"
      :assort-detail="assortDetail"
      @show="handleShowItem"
    />
  </div>
</template>

<script setup>
import { computed, reactive, watch, ref, toRaw } from 'vue'
import { dataTranslations as dt, getAssorts, notificationErrors } from "../../utils"
import { ElLoading } from 'element-plus'
import { _api_getProduct } from "../../api/index.js";
import PromotionProductItem from "../promotions/PromotionProductItem2.vue"
import ProductAssortSelectModal from '../products/ProductAssortSelectModal.vue';
import PromotionProductQuickView from "../promotions/PromotionProductQuickView.vue"

const props = defineProps({
  data: { type: Object, required: true },
  storeData: { type: Object, required: true },
  sources: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  is_login: { type: Boolean, default: false },
  isDistribute: { type: Boolean, default: false },
})
const emit = defineEmits(['show-coin', 'add', 'show', 'quick-add', 'view'])

const ids = computed(() => props.data?.store_product_ids || [])
const storeCurrency = computed(() => props.storeData?.currency || "TWD")
const action = "ADD_TO_CART"

const state = reactive({
  products : [],
  prodVisible: false,
})

const modalState = reactive({
  title: "",
  item: null,
  visible: false,
})

const filterParams = reactive({
  fields: "price_range,images,assorts",
})

const handleCloseItem = () => {
  modalState.visible = false
}

const handleShowItem = (item) => {
  // console.log("handleShowItem: ", toRaw(item));
  modalState.title = dt(item?.name_translations);
  modalState.item = item;
  modalState.item.assorts = getAssorts(item, storeCurrency.value);
  modalState.visible = true
}

const getDatas = async () => {
  window.ElFullPageLoading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
  });
  try {
    
    for (const id of ids.value) {
      const resp = await _api_getProduct(id, filterParams)
      // console.debug("products", resp?.images)
      if (Array.isArray(resp?.images) && resp?.images.length > 0 ) {
        resp.image_url = resp?.images[0]?.media?.url
      }
      state.products.push(resp)
    }
  } catch (error) {
    notificationErrors(error)
    // for test
  } finally {
    window.ElFullPageLoading && window.ElFullPageLoading.close();
  }
}

const showCoinLevel = (item) => {
    // 佣金詳情
    emit("show-coin", item)
}

const handleAddToCart = (assorts) => {
  emit("add", assorts)
}

const handleQuickAddToCart = async (item) => {
  if (!item?.assorts || !item?.assorts.length) {
    swal.fire({
      title: '查無商品可用規格',
      type: 'error',
    });
    return;
  }
  const assort = item?.assorts[0]
  // console.log("加入購物車", toRaw(item));
  const payload = {
    ptype: 'SPROD',
    store_product_id: item?.id,
    store_assort_id: assort?.id,
    quantity: 1,
    price: assort?.sale_price,
    prod_name: dt(item.name_translations),
  }
  
  emit("quick-add", { payloads: [payload], redirect: false, action })
}

const assortDetail = ref(true)
const handleQuickView = async (data, select_assort_btn = true) => {
  assortDetail.value = select_assort_btn
  modalState.title = dt(data.name_translations);
  modalState.item = data;
  state.prodVisible = true
  // console.log("商品詳情: ", toRaw(data));
}

const setPayload = (items) => {
  const payloads = items.map((item) => ({
    ...item,
    ptype: "SPROD",
  }))
  return payloads
}
const buyNowByAssort = (items) => {
  emit("quick-add", { payloads: setPayload(items), redirect: true, action })
}
const addToCartByAssort = (items) => {
  emit("quick-add", { payloads: setPayload(items), redirect: false, action })
}

// watch(
//   () => ids.value,
//   (v) => {
//     if (v.length ) {
//       getDatas()
//     }
//   },
//   { deep: true, immediate: true }
// )
defineExpose({ handleCloseItem, modalState })
</script>